import { coreAxios } from "@/declare/api/axios"
import { AxiosResponse } from "axios";
import qs from "qs";

/**
 * 添加或修改坐标轴
 * @param projectUuid 
 * @param data 
 * @param params 
 * @returns 
 */
export function createAxes(projectUuid: string, data: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/graphics/${projectUuid}/axes`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 批量添加或修改坐标轴
 * @param projectUuid 
 * @param data 
 * @param params 
 * @returns 
 */
export function createAxesMulti(projectUuid: string, data: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/graphics/${projectUuid}/axes/multi`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 批量获取坐标轴
 * @param projectUuid 
 * @param params 
 * @returns 
 */
export function findAxesListInGraphic(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/graphics/${projectUuid}/axes`, {
        params: {
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

/**
 * 删除坐标轴
 * @param uuid 
 * @param params 
 * @returns 
 */
export function deleteAxes(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/graphics/axes/${uuid}`, {
        params: {
            ...params,
        }
    })
}
